import type { StatsData } from "./schemas";

export default function Stats(props: StatsData) {
  const items = props.items ?? [];
  return (
    <section className="relative w-full bg-background py-14 px-6">
      <div className="max-w-4xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-y-10 gap-x-4 text-center">
        {items.map((s, i) => (
          <div key={i}>
            <div className="font-serif text-3xl md:text-4xl text-gold">
              {s.value}
              {s.suffix && <span className="text-foreground/70 text-xl ml-0.5">{s.suffix}</span>}
            </div>
            <div className="mt-2 text-[10px] tracking-[0.3em] uppercase text-foreground/60">
              {s.label}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
